import { MediaListItem } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import {
  CURRENT_SELECTION_ROW_SX,
  CurrentSelectionChip,
} from "./CurrentSelectionChip.js";

const SHOWN_TITLES = 3;

/** The pinned, read-only summary of a template placeholder filled by hand. */
export const HandBuiltContentRow = ({
  items,
}: {
  items: { id: string; title: string }[];
}) => {
  const { t } = useTranslate(["QuoteItem", "Global"]);
  const titles = items
    .slice(0, SHOWN_TITLES)
    .map(item => item.title)
    .join(", ");
  const moreCount = items.length - SHOWN_TITLES;
  return (
    <MediaListItem
      selected
      aria-current="true"
      StatusIcons={[
        <CurrentSelectionChip key="current-selection" variant="filledByHand" />,
      ]}
      sx={CURRENT_SELECTION_ROW_SX}
      title={t("{count, plural, one {# item} other {# items}}", {
        ns: "QuoteItem",
        count: items.length,
      })}
      description={
        moreCount > 0
          ? `${titles} ${t("and {count} more", { ns: "Global", count: moreCount })}`
          : titles
      }
    />
  );
};
